import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";

import {
	Logo,
	MobileMenuButton,
	MobileMenuContainer,
	NavbarButton,
	NavbarContainer,
	Header,
	NavStoreBadges,
	QrImage
} from "./Navbar.styled";
import { FlexRow } from "styles";
import { scrollPageTo } from "shared/scrollPage";
import BurgerMenu from "./BurgerMenu";
import LaunchBanner from "../LaunchBanner/LaunchBanner";
import StoreBadges from "../StoreBadges/StoreBadges";

const routeButtons = [
	{
		title: "Home",
		href: "/"
	},
	{
		title: "Support",
		href: "/support"
	}
];

export default function Navbar() {
	const router = useRouter();
	const [mobileMenuOpen, setMobileMenuOpen] = useState();

	const handleOpenMobileMenu = () => {
		setMobileMenuOpen(!mobileMenuOpen);
	};

	const handleLogoClick = useCallback(
		event => {
			if (router.pathname !== "/") return;
			event.preventDefault();
			scrollPageTo({ top: 0, behavior: "smooth" });
			if (window.location.hash) window.history.replaceState(null, "", "/");
		},
		[router.pathname]
	);

	return (
		<Header>
			<LaunchBanner />
			<NavbarContainer>
				<Link href="/" onClick={handleLogoClick}>
					<FlexRow style={{ minWidth: 125, cursor: "pointer" }}>
						<Image unoptimized src="/assets/icon/icon_rainbow.png" height={50} width={50} alt="Wishbox" />
						<Logo>Wishbox</Logo>
					</FlexRow>
				</Link>
				<QrImage>
					<Image
						unoptimized
						src="/assets/qr_code.png"
						height={350}
						width={350}
						style={{ width: "100%", height: "100%" }}
						alt=""
					/>
				</QrImage>
				<FlexRow style={{ gap: 10, alignItems: "center" }}>
					<NavStoreBadges>
						<StoreBadges compact />
					</NavStoreBadges>
					{routeButtons.map(({ href, title }) => (
						<Link href={href} key={title}>
							<NavbarButton selected={router.pathname === href}>{title}</NavbarButton>
						</Link>
					))}
					<BurgerMenu onClick={handleOpenMobileMenu} />
				</FlexRow>
			</NavbarContainer>
			{mobileMenuOpen && (
				<MobileMenuContainer>
					{routeButtons.map(({ href, title }) => (
						<Link href={href} key={title}>
							<MobileMenuButton>{title}</MobileMenuButton>
						</Link>
					))}
					<div style={{ padding: 20, display: "flex", justifyContent: "center" }}>
						<StoreBadges compact align="center" />
					</div>
				</MobileMenuContainer>
			)}
		</Header>
	);
}
